<template>
	<InlineSvg
		:src="computedIcon"
		:width="width"
		:height="height"
		v-bind="$attrs"
		:class="rotateClasses"
	/>
</template>

<script setup>
import InlineSvg from './inline-svg';
import { loadFile } from '@/v2/utils/index';
import { computed } from 'vue';
import { useLayoutStore } from '../store/shared/layout-store';

const props = defineProps({
	name: String,
	width: {
		type: String,
	},
	height: {
		type: String,
	},
	placeholder: {
		type: String,
		default: 'image-x',
	},
});

const layoutStore = useLayoutStore();

const computedIcon = computed(() => {
	if (!props.name) {
		return loadFile(`assets/v2/image/icons/${props.placeholder}.svg`);
	}
	if (props.name.startsWith('assets/v2')) {
		return loadFile(props.name);
	} else {
		return loadFile(`assets/v2/image/icons/${props.name}.svg`);
	}
});

const parsedName = computed(() => {
	if (props.name.startsWith('assets/v2')) {
		const splitted = props.name.split('/');
		return splitted[splitted.length - 1].replace('.svg', '');
	} else {
		return props.name;
	}
});

const rtlRotate180 = ['arrow-narrow-right', 'arrow-right', 'send-message', 'arrow-right-full'];
const rtlRotateMinus90 = ['arrow-up-right'];

const rotateClasses = computed(() => {
	if (!layoutStore.isRTL) return;
	if (rtlRotate180.includes(parsedName.value)) {
		return 'tw-rotate-180';
	} else if (rtlRotateMinus90.includes(parsedName.value)) {
		return '-tw-rotate-90';
	}
});
</script>

<style lang="scss" scoped></style>
